'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _A = require('./A');

var _A2 = _interopRequireDefault(_A);

var _propsComparer = require('../../utils/propsComparer');

var _propsComparer2 = _interopRequireDefault(_propsComparer);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _noop = require('../../utils/noop');

var _noop2 = _interopRequireDefault(_noop);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRouter = require('react-router');

var _Link = require('./Link.scss');

var _Link2 = _interopRequireDefault(_Link);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Link = (_temp2 = _class = function (_Component) {
    (0, _inherits3.default)(Link, _Component);

    function Link() {
        var _ref;

        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, Link);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Link.__proto__ || (0, _getPrototypeOf2.default)(Link)).call.apply(_ref, [this].concat(args))), _this), _this.refreshCurrentPage = function () {
            if (_this.props.route && '' + window.location.pathname + window.location.search === _this.props.to) {
                window.location.reload();
            }
        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    (0, _createClass3.default)(Link, [{
        key: 'shouldComponentUpdate',
        value: function shouldComponentUpdate(nextProps) {
            return (0, _propsComparer2.default)(this.props, nextProps, ['children', 'className', 'primary', 'primaryWeak', 'secondary', 'target', 'to']);
        }
    }, {
        key: 'render',
        value: function render() {
            var _classNames;

            var _props = this.props,
                className = _props.className,
                children = _props.children,
                onClick = _props.onClick,
                onMouseOut = _props.onMouseOut,
                onMouseOver = _props.onMouseOver,
                primary = _props.primary,
                primaryWeak = _props.primaryWeak,
                rel = _props.rel,
                route = _props.route,
                secondary = _props.secondary,
                target = _props.target,
                to = _props.to;


            var classes = (0, _classnames2.default)(_Link2.default.link, (_classNames = {}, (0, _defineProperty3.default)(_classNames, _Link2.default.primary, primary), (0, _defineProperty3.default)(_classNames, _Link2.default['primary-weak'], primaryWeak), (0, _defineProperty3.default)(_classNames, _Link2.default.secondary, secondary), _classNames), className);

            var linkProps = {
                className: classes
            };
            if (children) {
                linkProps.children = children;
            }
            if (onMouseOut) {
                linkProps.onMouseOut = onMouseOut;
            }
            if (onMouseOver) {
                linkProps.onMouseOver = onMouseOver;
            }
            if (rel) {
                linkProps.rel = rel;
            }

            linkProps.onClick = onClick || this.refreshCurrentPage;

            // only add a 'target' if not a route
            if (!route && target) {
                linkProps.target = target;
            }

            // depending on a route, add a 'to' or 'href'
            if (route && to) {
                linkProps.to = to;
            }
            if (!route && to) {
                linkProps.href = to;
            }

            return route ? _react2.default.createElement(_reactRouter.Link, linkProps) : _react2.default.createElement(_A2.default, linkProps);
        }
    }]);
    return Link;
}(_react.Component), _class.defaultProps = {
    children: '',
    className: '',
    onMouseOut: _noop2.default,
    onMouseOver: _noop2.default,
    primary: false,
    primaryWeak: false,
    rel: '',
    route: false,
    secondary: false,
    target: '',
    to: ''
}, _temp2);
exports.default = Link;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Link/Link.js
// module id = rkxl
// module chunks = 57